import { useState, useEffect } from 'react'
import { getHttp } from 'src/api'
import { PATH_API } from 'src/helpers/path'
import { useAppContext } from 'src/helpers/app'

export function useTopCollections() {
  const { sessionID } = useAppContext()
  const [data, setData] = useState<any>({})
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!sessionID) return

    setLoading(true)
    setError(null)

    // First, try to get topCollections from localStorage (from ResultCalculationPage)
    const topCollectionsData = localStorage.getItem('topCollections')
    if (topCollectionsData) {
      try {
        const parsedData = JSON.parse(topCollectionsData)
        console.log('Using topCollections from localStorage:', parsedData)
        setData(parsedData)
        setLoading(false)
        return // If we have data from localStorage, don't call API
      } catch (e) {
        console.error('Error parsing topCollections from localStorage:', e)
        // If parsing fails, continue to call API
      }
    }

    // If no localStorage data, call API as fallback
    console.log('No topCollections in localStorage, calling API...')
    getHttp(`${PATH_API.getTopCollections}?uniqueIdentifier=${sessionID}`)
      .then((res) => {
        const topCollections = res?.data?.topCollections || {}
        console.log('API response topCollections:', topCollections)
        setData(topCollections)
        // Save to localStorage for future use
        localStorage.setItem('topCollections', JSON.stringify(topCollections))
      })
      .catch((err) => {
        console.error('API call failed:', err)
        setError('Failed to fetch collections')
        setData({})
      })
      .finally(() => setLoading(false))
  }, [sessionID])

  console.log('useTopCollections data:', data)
  return { data, loading, error }
}
